import { render, staticRenderFns } from "./CSPCurriculum.vue?vue&type=template&id=33325214&scoped=true&"
import script from "./CSPCurriculum.vue?vue&type=script&lang=js&"
export * from "./CSPCurriculum.vue?vue&type=script&lang=js&"
import style0 from "./CSPCurriculum.vue?vue&type=style&index=0&id=33325214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33325214",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
